import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseCheckbox = {
  backgroundColor: css`var(--cse-checkbox-background-color, ${csFormControl.backgroundColor})`,
  checkedBackgroundColor: css`var(--cse-checkbox-checked-background-color, ${csFormControl.backgroundColorChecked})`,
  checkedBackgroundColorHover: css`var(--cse-checkbox-checked-background-color-hover, ${csFormControl.backgroundColorCheckedHover})`,
  backgroundColorDisabled: css`var(--cse-checkbox-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderColor: css`var(--cse-checkbox-border-color, ${csFormControl.borderColor})`,
  checkedBorderColor: css`var(--cse-checkbox-checked-border-color, ${csFormControl.borderColorChecked})`,
  borderColorHover: css`var(--cse-checkbox-border-color-hover, ${csFormControl.borderColorHover})`,
  borderRadius: css`var(--cse-checkbox-border-radius, ${csBorder.radiusMinimal})`,
  borderWidth: css`var(--cse-checkbox-border-width, ${csFormControl.borderWidth})`,
  opacityDisabled: css`var(--cse-checkbox-opacity-disabled, .35)`,
  outlineFocus: css`var(--cse-checkbox-outline-focus, ${csFormControl.outlineFocus})`,
  height: css`var(--cse-checkbox-height, 20px)`,
  width: css`var(--cse-checkbox-width, 20px)`,
  gap: css`var(--cse-checkbox-gap, ${csSpacing.spacing05})`,

  color: css`var(--cse-checkbox-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-checkbox-color-disabled, ${csColorText.placeholder})`,
  fontFamily: css`var(--cse-checkbox-font-family, ${csFormControl.fontFamily})`,
  fontSize: css`var(--cse-checkbox-font-size, ${csFormControl.fontSize})`,

  iconColor: css`var(--cse-checkbox-icon-color, ${csColorText.white})`,

  groupGap: css`var(--cse-checkbox-group-gap, ${csSpacing.spacing05})`,
}

export const style: CSSResult = css`
  .cse-checkbox {
    align-items: center;
    display: inline-flex;
  }

  input {
    flex: 0 0 auto;
    appearance: none;
    -webkit-appearance: none;
    background-color: ${cseCheckbox.backgroundColor};
    border-width: ${cseCheckbox.borderWidth};
    border-style: solid;
    border-color: ${cseCheckbox.borderColor};
    border-radius: ${cseCheckbox.borderRadius};
    width: ${cseCheckbox.width};
    height: ${cseCheckbox.height};
    margin: 0;
    transition-duration: ${csTransition.duration};
    transition-property: border-width, border-color, box-shadow, background-color;
    transition-timing-function: ${csTransition.timingFunction};
  }

  input:focus,
  input:focus-visible {
    outline: ${cseCheckbox.outlineFocus};
  }

  .cse-checkbox.checked input {
    background-color: ${cseCheckbox.checkedBackgroundColor};
    border-color: ${cseCheckbox.checkedBorderColor};
  }

  .cse-checkbox:not(.disabled), .cse-checkbox:not(.disabled) input {
    cursor: pointer;
  }

  .cse-checkbox:not(.disabled):hover input {
    border-color: ${cseCheckbox.borderColorHover};
  }

  .cse-checkbox.disabled:not(.checked) input {
    background-color: ${cseCheckbox.backgroundColorDisabled};
    pointer-events: none;
  }

  .cse-checkbox.disabled.checked input {
    opacity: ${cseCheckbox.opacityDisabled};
    pointer-events: none;
  }

  .cse-checkbox.checked:not(.disabled):hover input {
    background-color: ${cseCheckbox.checkedBackgroundColorHover};
  }

  .label {
    color: ${cseCheckbox.color};
    display: inline-block;
    font-family: ${cseCheckbox.fontFamily};
    font-size: ${cseCheckbox.fontSize};
    line-height: normal;
    margin-left: ${cseCheckbox.gap};
    user-select: none;
    vertical-align: top;
  }

  .cse-checkbox.disabled .label {
    color: ${cseCheckbox.colorDisabled};
  }

  .cse-checkbox:not(.disabled) .label {
    cursor: pointer;
  }

  [icon-role="cse-checkbox.check"] {
    color: ${cseCheckbox.iconColor};
    position: absolute;
    width: ${cseCheckbox.width};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
`

export const groupStyle = css`
  .cse-checkbox-group {
    display: flex;
    flex-direction: column;
    gap: ${cseCheckbox.groupGap};
  }
`
